import { Button, Col, Typography } from "antd";
import React from "react";
import { InputSelect } from "../../../../shared/components";
import { useCreateSushiLunchProduct } from "../../hooks";

const { Text } = Typography;

export const SushiLunchProductsForm = ({
  setOpenModalCreate,
}: {
  setOpenModalCreate: (val: boolean) => void;
}) => {
  const { control, handleSubmit, loading } = useCreateSushiLunchProduct({
    setOpenModalCreate,
  });

  return (
    <form onSubmit={handleSubmit}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Producto:</Text>
        <InputSelect
          name="product_id"
          control={control}
          service="products"
          keyValue="id"
          keyLabel="name"
          label="Selecciona un producto"
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        loading={loading}
      >
        Crear
      </Button>
    </form>
  );
};
